export const USER_EVENTS = {
  update: 'update',
  updateTimeOfDay: 'updateTimeOfDay',
  updateUsername: 'updateUsername',
};
